import {CircularProgress} from "@mui/material";

export function LoadingIndicator(): JSX.Element
{
    return (
        <CircularProgress />
    )
}